import Vue from 'vue'
import Vuex from 'vuex'
import loading from './loading';
import trialBookingFlow from './trialBookingFlow';
import user from './user';
import zdj from './zdj';
import ui from './ui';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        user,
        loading,
        trialBookingFlow,
        zdj,
        ui,
    }
});

export default store;